import React, { useEffect, useReducer } from 'react'

import { initialState, iamReducer, SET_PERMISSIONS, SET_PERMISSIONS_ERROR } from '../iamReducer/iamReducer'
import { useServices } from '../../serviceContext/ServiceContext'

import { IamDispatchContext, IamStateContext } from './IamContext'
import { useAuthState } from '@percent/partner-dashboard/common/hooks'
import { AbilityList } from './IamContext.types'
import { logger } from '@percent/partner-dashboard/capabilities/logger'

type ContextControllerProps = {
  children: React.ReactNode
  rulesList: AbilityList
}

export function IamContextController({ children, rulesList }: ContextControllerProps) {
  const [state, dispatch] = useReducer(iamReducer, initialState)
  const { isAuthorised, isAuthorising } = useAuthState()
  const { iamService } = useServices()

  useEffect(() => {
    const getPermissionsData = async () => {
      try {
        const response = await iamService.getPermissions()

        if (response?.data?.data) {
          dispatch({
            type: SET_PERMISSIONS,
            payload: {
              permissions: response.data.data,
              rulesList
            }
          })
        } else {
          dispatch({ type: SET_PERMISSIONS_ERROR })
        }
      } catch (err) {
        logger(err)
        dispatch({ type: SET_PERMISSIONS_ERROR })
      }
    }

    if (isAuthorised && !isAuthorising) {
      getPermissionsData()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isAuthorised, isAuthorising])

  return (
    <IamStateContext.Provider value={state}>
      <IamDispatchContext.Provider value={dispatch}>{children}</IamDispatchContext.Provider>
    </IamStateContext.Provider>
  )
}
